export default "__VITE_ASSET__B_Mljtm3__"